import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Fade-up on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal (hero signature moment)
export const MaskLines = ({ lines = [], className = "", lineClassName = "", start = 0 }) => (
  <span className={className} aria-label={lines.join(" ")}>
    {lines.map((line, i) => (
      <span key={`${i}-${line}`} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, ease: EASE, delay: start + i * 0.14 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export { EASE };
